import Breadcrumbs from "components/Breadcrumbs"
import { BreadcrumbsDetail } from "components/Breadcrumbs/types"
import { PATH } from "constants/path"

const StorageUsageHeader = () => {
  const listBreadcrumbs: BreadcrumbsDetail[] = [
    {
      name: "Workspace setting",
      path: PATH.workspaceSetting,
    },
    {
      name: "Storage usage detail",
    },
  ]

  return (
    <div className="flex w-full items-center h-full pl-[24px]">
      <Breadcrumbs
        listBreadcrumbs={listBreadcrumbs}
        className="flex w-full "
        overflow
      />
    </div>
  )
}

export default StorageUsageHeader
